import {
  Component,
  HostListener,
  Input,
  OnDestroy,
  OnInit,
  ViewChild,
} from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NbDialogService } from "@nebular/theme";
import { map, takeUntil } from "rxjs/operators";
import { User } from "../../@core/data/users";
import { UserService } from "../../@core/services/user.service";
import {
  convertTimestamp,
  convertTimestampsPipe,
} from "../../@core/utils/convertTimestamps.service";

import { DialogYesNoPromptComponent } from "../dialog-yesno-prompt/dialog-yesno-prompt.component";

import { find, remove, clone } from "lodash";
import { DialogQnAContentComponent } from "../dialog-qna-content/dialog-qna-content.component";
import QnA from "../../models/qna.model";
import { QnAService } from "../../services/qna.service";
import { WhereList } from "../../models/pagination";
import Course from "../../models/course.model";
import Quiz from "../../models/quiz.model";
import LectureContent from "../../models/lecture-content.model";
import { Subject } from "rxjs";
import { NotificationService } from "../../services/notifications.service";

@Component({
  selector: "ngx-view-qnas",
  styleUrls: ["./view-qnas.component.scss"],
  templateUrl: "./view-qnas.component.html",
})
export class ViewQnAsComponent implements OnInit, OnDestroy {
  private destroy$: Subject<void> = new Subject<void>();
  @Input() mode?: string = "course"; //home / tutor / course / detail /review /
  @Input() courseId?: string = "";
  @Input() course?: Course = new Course();
  @Input() lecture?: LectureContent = new LectureContent();
  @Input() quiz?: Quiz = new Quiz();

  submitted = false;
  loading = false;
  cursor: any;
  done = false;

  display?: QnA[] = [];
  qnas?: QnA[] = [];

  pageSize = 3;
  strSearch = "";

  uid = "anonymous";
  subscribe: any;

  constructor(
    private qnaService: QnAService,
    public userService: UserService,
    private notiService: NotificationService,
    private dialogService: NbDialogService
  ) {}

  ngOnInit() {
    this.userService
      .getCurrentUser()
      .pipe(takeUntil(this.destroy$))
      .subscribe((user: User) => {
        if (user && user.uid != this.uid) {
          this.uid = user.uid;
        } else {
          this.uid = "anonymous";
        }
        this.getQnAs();
      });
  }

  ngOnDestroy() {
    //console.log("Items destroyed");
    this.destroy$.next();
    this.destroy$.complete();
  }

  getMoreQnAs(): void {
    this.pageSize = 12;
    this.getQnAs();
  }

  search() {
    this.strSearch = this.strSearch.toLowerCase();
  }

  reportQnA(item) {
    //
  }

  close() {}

  //Control event lazyloading qna feedback
  onSearch(): void {
    this.strSearch = this.strSearch.toLowerCase();

    this.display = this.qnas.filter(
      function (item) {
        return (
          item.title.toLowerCase().includes(this.title) ||
          item.description.toLowerCase().includes(this.title)
        );
      },
      { title: this.strSearch }
    );
  }

  onNewQnA() {
    let qnaNew = new QnA();
    if (this.course && this.course.id) {
      qnaNew.courseId = this.course.id;
      qnaNew.refTitle = this.course.title;
      qnaNew.privacy = this.course.privacy;
    }
    if (this.lecture && this.lecture.id) {
      qnaNew.lectureId = this.lecture.id;
      qnaNew.refTitle = this.lecture.title;
      qnaNew.privacy = this.lecture.privacy;
    }
    if (this.quiz && this.quiz.id) {
      qnaNew.quizId = this.quiz.id;
      qnaNew.refTitle = this.quiz.title;
      qnaNew.privacy = this.quiz.privacy;
    }

    this.dialogService
      .open(DialogQnAContentComponent, {
        context: {
          header: "Tạo câu hỏi",
          mode: "new",
          qna: qnaNew,
        },
      })
      .onClose.subscribe((value) => {
        if (value) {
          this.qnas = [value, ...this.qnas];
          this.display = [...this.qnas];

          if (
            this.course &&
            this.course.id &&
            this.course.createdBy != this.uid
          ) {
            //Send notification to tutor
            this.notiService.create(
              "Hỏi",
              `qnas`,
              value.id,
              this.courseId,
              value.title,
              value.refTitle,
              this.course && this.course.id ? this.course.createdBy : "",
              `/qna/${value.id}`,
              this.courseId
            );
          }
        }
      });
  }

  onEdit(item: QnA) {
    if (item) {
      for (let i = 0; i < this.qnas.length; i++) {
        if (this.qnas[i].id == item.id) {
          this.qnas[i] = item;
          break;
        }
      }
      this.display = [...this.qnas];
    }
  }

  onDelete(value) {
    if (value) {
      remove(this.qnas, (e) => {
        return e.id == value;
      });
      this.display = [...this.qnas];
    }
  }

  private getQnAs(): void {
    this.loading = true;

    if (this.mode == "student") {
      {
        this.subscribe = this.qnaService.getMyQnAs(
          this.uid,
          this.pageSize,
          this.cursor
        );
      }
    } else {
      if (this.courseId != "") {
        const wheres: WhereList[] = [];
        wheres.push({
          fieldPath: "courseId",
          value: this.courseId,
        });
        this.subscribe = this.qnaService.getQnAs(
          wheres,
          this.pageSize,
          this.cursor
        );
      } else {
        this.subscribe = this.qnaService.getPublishedQnAs(
          "",
          this.pageSize,
          this.cursor
        );
      }
    }

    this.subscribe
      .then((querySnapshot) => {
        if (querySnapshot.docs.length > 0) {
          this.cursor = querySnapshot.docs[querySnapshot.docs.length - 1];

          querySnapshot.forEach((doc) => {
            let data = new QnA();
            data = doc.data();
            data.id = doc.id;
            data.createdOn = convertTimestamp(doc.data().createdOn);

            let item = find(this.qnas, ["id", data.id]);
            if (item) {
              item = data;
            } else {
              this.qnas.push(data);
            }
          });

          this.display = [...this.qnas];
        } else {
          this.cursor = null;
          this.done = true;
        }

        this.loading = false;
      })
      .catch((error) => {});
  }
}
